import { useQuery } from "react-query"
import { createAboutProject, getAboutProject, getAboutProjectById, updateAboutProject } from "../../../services/aboutProjectSvc"
import { LANGUAGES } from "../../../mock/languages"
import { useNotification } from "../../../context/NotificationContext"
import { useState } from "react"
import { lang } from "../../../types/lang"
import { useFormik } from "formik"
import { UploadImage } from "../../../components/common/uploadImage/UploadImage"
import { PLACEHOLDER_IMAGE_URL } from "../../../mock/constants"
import imgBaseUrl from "../../../utils/imgBaseUrl"

const AboutProjectPage = () => {
  const { data: aboutProject } = useQuery('aboutProject', getAboutProject)
  const { showNotification } = useNotification();
  const [activeTab, setActiveTab] = useState<lang>("uz");

  const aboutProjectId = aboutProject?.[0]?.id ? Number(aboutProject[0].id) : null;

  const { data: aboutProjectById } = useQuery("getAboutProjectById", () => getAboutProjectById(aboutProjectId), {
    enabled: !!aboutProjectId
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: {
        uz: aboutProjectById?.title_uz || '',
        ru: aboutProjectById?.title_ru || '',
        en: aboutProjectById?.title_en || '',
      },
      description: {
        uz: aboutProjectById?.description_uz || '',
        ru: aboutProjectById?.description_ru || '',
        en: aboutProjectById?.description_en || '',
      },
      image: null,
    },
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append('title_uz', values.title.uz);
      formData.append('title_ru', values.title.ru);
      formData.append('title_en', values.title.en);
      formData.append('description_uz', values.description.uz);
      formData.append('description_ru', values.description.ru);
      formData.append('description_en', values.description.en);

      if (values.image) {
        formData.append('image', values.image);
      }

      try {
        if (aboutProjectId) {
          const res = await updateAboutProject(aboutProjectId, formData);
          if (res?.success) {
            showNotification("Muvaffaqiyatli", "Loyiha haqida yangilandi", "success")
          }
        } else {
          const res = await createAboutProject(formData);
          if (res?.success) {
            showNotification("Muvaffaqiyatli", "Loyiha haqida qo'shildi", "success")
          }
        }
      } catch (e) {
        showNotification("Xatolik!", "", "error")
      }
    },
  })

  const handleTabChange = (lang) => {
    setActiveTab(lang);
  };

  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-title">Loyiha haqida</h4>
        <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
          {LANGUAGES.map((lang) => (
            <li className="nav-item" key={lang.key}>
              <button
                className={`nav-link ${activeTab === lang.key ? 'active' : ''}`}
                onClick={() => handleTabChange(lang.key)}
              >
                {lang.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
      <div className="card-body">
        <form
          className="form"
          onSubmit={formik.handleSubmit}
          encType="multipart/form-data"
        >
          <div className="card-body p-9">
            <div className="row mb-6">
              <label className="col-lg-4 col-form-label required fw-bold fs-6">
                Loyiha nomi
              </label>
              <div className="col-lg-8 fv-row">
                <textarea
                  className="form-control form-control-lg form-control-solid"
                  placeholder="Loyiha nomi"
                  name={`title.${activeTab}`}
                  value={formik.values.title[activeTab]}
                  onChange={formik.handleChange}
                />
                {formik.touched.title?.[activeTab] && formik.errors.title?.[activeTab] && (
                  <div className="text-danger">{formik.errors.title[activeTab]?.toString()}</div>
                )}
              </div>
            </div>

            <div className="row mb-6">
              <label className="col-lg-4 col-form-label required fw-bold fs-6">
                Loyiha haqida matn
              </label>
              <div className="col-lg-8 fv-row">
                <textarea
                  className="form-control form-control-lg form-control-solid"
                  placeholder="Loyiha haqida matn"
                  name={`description.${activeTab}`}
                  value={formik.values.description[activeTab]}
                  onChange={formik.handleChange}
                />
                {formik.touched.description?.[activeTab] && formik.errors.description?.[activeTab] && (
                  <div className="text-danger">{formik.errors.description[activeTab]?.toString()}</div>
                )}
              </div>
            </div>


            <div className="row mb-6">
              <label className="col-lg-4 col-form-label required fw-bold fs-6">
                Banner rasmi
              </label>
              <div className="col-lg-8 fv-row">
                <UploadImage defaultImage={aboutProjectById?.image ? imgBaseUrl(aboutProjectById?.image!) : PLACEHOLDER_IMAGE_URL} imageSizes={"banner"} onImageUpload={(file) => {
                  if (file) {
                    formik.setFieldValue('image', file);
                  }
                }} />
                {formik.touched.image && formik.errors.image && (
                  <div className="text-danger">{formik.errors.image}</div>
                )}
              </div>
            </div>
          </div>
          <div className="card-footer text-end">
            <button className="btn btn-primary" disabled={formik.isSubmitting}>{formik.isSubmitting ? "Saqlanmoqda..." : "Saqlash"}</button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AboutProjectPage
